import type { TypeSelectItem } from '../model';

type Props = {
  item: TypeSelectItem | undefined;
  showDescription?: boolean;
};

const OpenAccountFormTypeItem = ({ item, showDescription = true }: Props) => {
  if (!item) {
    return null;
  }

  return (
    <div>
      <div className="headline4">{item.typeCode}</div>
      {showDescription && (
        <div className="p5 text-secondary text-balance">
          {item.typeDescription}
        </div>
      )}
    </div>
  );
};

export { OpenAccountFormTypeItem };
